import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage, ApiRequest } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import Help from '../../Common/Help/Help';
import Tooltip from 'reactstrap/lib/UncontrolledTooltip';
import SingleDatePickerWrapper from '../../Common/SingleDatePickerWrapper/SingleDatePickerWrapper';
import MultipleDatePickerWrapper from '../../Common/MultipleDatePickerWrapper/MultipleDatePickerWrapper';
import TimeOptions from '../../Common/TimeOptions/TimeOptions';
import TimeBeforeOptions from '../../Common/TimeBeforeOptions/TimeBeforeOptions';
import TimeBeforeOptionsPublic from '../../Common/TimeBeforeOptionsPublic/TimeBeforeOptionsPublic';
import TimeAfterOptions from '../../Common/TimeAfterOptions/TimeAfterOptions';
import moment from 'moment';
import { DateUtils } from 'react-day-picker';
import deleteIcon from '../../../images/icons/delete.svg';
import './Dates.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class Dates extends Component {
	constructor(props) {
		super(props);
		this.state = { 
			selectedDay: null,
			selectedDays: this.props.wizard.dates,
			videos: [],
			isWizardOpen: false,
		}
	}

    componentDidMount() {
		this.getAdminVideos();
	}

	componentWillReceiveProps(props) {
		if (props.wizard.dates) {
			this.setState({
				selectedDays: props.wizard.dates,
			});
		}
	}

	getAdminVideos = () => {
        const getVideos = async () => {
            try {
                const videosResponse = await getVideosAPI();
                console.log('videosResponse: ', videosResponse);
                if (videosResponse.data) {
                    const videos = videosResponse.data;
                    this.setState({
                        videos,
                    });
                }
            } catch (error) {
                console.log('error', error);
            }
        };

        async function getVideosAPI() {
            return await ApiRequest('/admin/videos', {
                method: 'GET',
            });
        }
        getVideos();
    }

	handleDayChange = (day, input) => {
		this.setState({
            selectedDay: day
		});
		this.props.handleChangeDateWizard(day, input.props.object, input.props.name);
	}

	handleDayVODChange = (day, input) => {
		this.setState({
            selectedDay: day
		});
		this.props.handleChangeDateVOD(day, input.props.object, input.props.name);
	}

	handleDayEventChange = (day, input) => {
		this.setState({
            selectedDay: day
		});
		this.props.handleChangeDateEvent(day, input.props.object, input.props.name, input.props.event);
	}
	
	handleDayClick = (day, { selected }) => {
        const { selectedDays } = this.state;
        if (selected) {
            const selectedIndex = selectedDays.findIndex(selectedDay =>
                DateUtils.isSameDay(selectedDay, day)
            );
            selectedDays.splice(selectedIndex, 1);
        } else {
            selectedDays.push(day);
        }
		this.setState({ selectedDays });
		this.props.handleChangeDateWizard(this.state.selectedDays, 'dates');
	}

	toggleWizard = () => {
		let isWizardOpen = this.state.isWizardOpen;
		this.setState({
			isWizardOpen: !isWizardOpen,
		});
	}

	renderHelp = () => {
		let event_type = this.props.event.details.event_type;
        if (event_type !== 'Video On Demand' && event_type !== 'Live Stream' && event_type !== 'Scheduled Content') {
			return (
				strings.help2.map((help, i) =>
					<Help help={help} key={i} />
				)
			);
		}
	}
	
	renderWizard = () => {
		let isStreamingEvent = true;
		let event_type = this.props.event.details.event_type;
        if (event_type !== 'Video On Demand' && event_type !== 'Live Stream' && event_type !== 'Scheduled Content') {
			isStreamingEvent = false;
		}
		const videos = this.state.videos;
		let createEventUrl = 'https://www.youtube.com/channel/UC30U07xVY2zbooskb9VpRzg/videos';
		let compUrl = 'https://www.youtube.com/channel/UC30U07xVY2zbooskb9VpRzg/videos';
		let pricingUrl = 'https://www.youtube.com/channel/UC30U07xVY2zbooskb9VpRzg/videos';
		if (videos.length > 0) {
			videos.forEach((video) => {
				if (video.title.includes('Creating New Event')) {
					createEventUrl = `https://www.youtube.com/watch?v=${video.youtube_id}`;
				}
				if (video.title.includes('Creating Comp Tickets')) {
					compUrl = `https://www.youtube.com/watch?v=${video.youtube_id}`;
				}
				if (video.title.includes('Customize Pricing')) {
					pricingUrl = `https://www.youtube.com/watch?v=${video.youtube_id}`;
				}
			});
		}
		if (this.props.event.details.event_type !== 'Video On Demand') {
			return (
				<div className="container">
					{this.props.event.details.event_id && (
						<button
							className="showtix-button__small showtix-button showtix-background__primary-1"
							onClick={this.toggleWizard}
						>
							<span>Add Additional Dates</span>
						</button>
					)}
					{(this.state.isWizardOpen || !this.props.event.details.event_id) && (
						<React.Fragment>
							<h1>{strings.titleWizard}</h1>
							<div className="row">
								<div className="col-12 col-lg-9">
									<div className="row">
										<div className="col-12 col-md-5">
											<div className="showtix-form__group">
												<label className="showtix-label" htmlFor="wizard-dates">{strings.when}</label>

												<div className="showtix-form__input">
													<MultipleDatePickerWrapper 
														object="dates" 
														id="wizard-dates"
														type="multiple_date"
														disablePrevious={true}
														handleDayClick={this.handleDayClick}
														selectedDays={this.state.selectedDays}
													/>
												</div>

												<div className="showtix-note">
													{strings.multipleDates}
												</div>
											</div>
										</div>

										<div className="col-12 col-md-4">
											<div className="showtix-form__group">
												<label className="showtix-label" htmlFor="wizard-time">{strings.whatTime}
													<span id="tooltip-whatTime" className="showtix-tooltip">!</span>
													<Tooltip placement="top" target="tooltip-whatTime">
														{strings.whatTimeTooltip}
													</Tooltip>
												</label>

												<div className="showtix-form__select">
													<select
														className="showtix-input"
														object="time" 
														name="" 
														id="wizard-time"
														onChange={this.props.handleChangeWizard}
														value={this.props.wizard.time}
													>
														<TimeOptions />
													</select>
												</div>
											</div>
										</div>
									</div>

									<div className="row">
										<div className="col-12 col-md-4">
											<div className="showtix-form__group">
												<label className="showtix-label" htmlFor="wizard-presale-start_date">{strings.presaleStart}
													<span id="tooltip-presaleStart" className="showtix-tooltip">!</span>
													<Tooltip placement="top" target="tooltip-presaleStart">
														{strings.presaleStartTooltip}
													</Tooltip>
												</label>

												<div className="showtix-form__multiple">
													<div className="showtix-form__input">
														<SingleDatePickerWrapper 
															object="presale" 
															name="start_date" 
															id="wizard-presale-start_date"
															disablePrevious={true}
															handleDayChange={this.handleDayChange}
															selectedDays=""
															disabled={this.props.wizard.dates.length === 0}
														/>
													</div>

													<div className="showtix-form__select">
														<select
															className="showtix-input"
															object="presale" 
															name="start_time" 
															id="wizard-presale-start_time"
															onChange={this.props.handleChangeWizard}
														>
															<TimeOptions />
														</select>
													</div>
												</div>
											</div>
										</div>

										<div className="col-12 col-md-4">
											<div className="showtix-form__group">
												<label className="showtix-label" htmlFor="wizard-presale-end_date">{strings.presaleEnd}</label>

												<div className="showtix-form__multiple">
													<div className="showtix-form__input">
														<SingleDatePickerWrapper 
															object="presale" 
															name="end_date" 
															id="wizard-presale-end_date"
															disablePrevious={true}
															handleDayChange={this.handleDayChange}
															selectedDays=""
														/>
													</div>

													<div className="showtix-form__select">
														<select
															className="showtix-input"
															object="presale" 
															name="end_time" 
															id="wizard-presale-end_time"
															onChange={this.props.handleChangeWizard}
														>
															<TimeOptions />
														</select>
													</div>
												</div>
											</div>
										</div>

										<div className="col-12 col-md-4">
											<div className="showtix-form__group">
												<label className="showtix-label" htmlFor="wizard-presale-password">{strings.presalePassword}</label>

												<div className="showtix-form__input">
													<input
														className="showtix-input"
														type="text"
														object="presale"
														name="password"
														id="wizard-presale-password"
														onChange={this.props.handleChangeWizard}
													/>
												</div>
											</div>
										</div>
									</div>

									<div className="row">
										<div className="col-12 col-md-4">
											<div className="showtix-form__group">
												<label className="showtix-label" htmlFor="wizard-public-start_date">{strings.publicStart}*
													<span id="tooltip-publicStart" className="showtix-tooltip">!</span>
													<Tooltip placement="top" target="tooltip-publicStart">
														{strings.publicStartTooltip}
													</Tooltip>
												</label>

												<div className="showtix-form__multiple">
													<div className="showtix-form__input">
														<SingleDatePickerWrapper
															object="public"
															name="start_date"
															id="wizard-public-start_date"
															disablePrevious={true}
															handleDayChange={this.handleDayChange}
															selectedDays=""
														/>
													</div>

													<div className="showtix-form__select">
														<select
															className="showtix-input"
															object="public"
															name="start_time"
															id="wizard-public-start_time"
															onChange={this.props.handleChangeWizard}
														>
															<TimeOptions />
														</select>
													</div>
												</div>
												{this.props.isWizardError &&
												<div className="showtix-note error">
													{strings.publicSaleError}
												</div>
												}
											</div>
										</div>

										<div className="col-12 col-md-4">
											<div className="showtix-form__group">
												<label className="showtix-label" htmlFor="wizard-public-end_date">{strings.publicEnd}
													<span id="tooltip-publicEnd" className="showtix-tooltip">!</span>
													<Tooltip placement="top" target="tooltip-publicEnd">
														{strings.publicEndTooltip}
													</Tooltip>
												</label>

												<div className="showtix-form__select">
													<select
														className="showtix-input"
														object="public"
														name="end_time"
														id="wizard-public-end_time"
														onChange={this.props.handleChangeWizard}
														disabled={this.props.wizard.dates.length === 0}
														value={this.props.wizard.public.end_time}
													>
														<TimeBeforeOptionsPublic />
													</select>
												</div>
											</div>
										</div>
									</div>

									{/*  (this.props.event.prices.length > 0 && this.props.event.venue.sections.length > 0) &&
										<div className="row">
											<div className="col-12">
												<div className="showtix-form__group">
													<button
														className="showtix-button showtix-background__primary-1"
														onClick={this.props.toggleDatesModal}
													><span>{strings.customizePricing}</span></button>
												</div>
											</div>
										</div>
									*/}
									<div className="row mt-3">
										<div className="col-12 text-center">
											{ this.props.event.venue.venue_type === 'reserved' ?
												[
													(this.props.event.venue.sections.length > 0 ?
															<button
																className="showtix-button showtix-button-large is-blink showtix-background__primary-4"
																onClick={this.props.createEvents}
																disabled={ this.props.wizard.dates.length === 0 || this.props.event.prices.length <= 1  || this.props.isWizardError || this.props.wizard.public.start_date === null || this.props.event.venue.sections.length === 0 }
															>
																<span>{strings.createEvents}</span>
															</button>
															:
															<button
																className="showtix-button showtix-button-large is-blink showtix-background__primary-4"
																onClick={this.props.createEvents}
																disabled={this.props.wizard.dates.length === 0  || this.props.event.prices.length <= 1 || this.props.wizard.public.start_date === null || this.props.event.venue.sections.length === 0 }
															>
																<span>{strings.createEvents}</span>
															</button>
													)
												]
												:
												<button
													className="showtix-button showtix-button-large is-blink showtix-background__primary-4"
													onClick={this.props.createEvents}
													disabled={this.props.wizard.dates.length === 0 || this.props.event.prices.length <= 1 || this.props.wizard.public.start_date === null || (!isStreamingEvent && this.props.event.venue.sections.length === 0)}
												>
													<span>{strings.createEvents}</span>
												</button>
											}
										</div>
									</div>
								</div>

								{ (strings.help1 && strings.help2) &&
									<React.Fragment>
										<div className="col-12 col-lg-3">
											<div className="showtix-box">
												<div className="showtix-padder">
													<h3 className="showtix-box__title">{strings.video.title}</h3>
													<p><a href={createEventUrl} target="_blank" rel="noopener">{strings.video.content1}</a></p>
													<p><a href={compUrl} target="_blank" rel="noopener">{strings.video.content2}</a></p>
													<p><a href={pricingUrl} target="_blank" rel="noopener">{strings.video.content3}</a></p>
												</div>	
											</div>
											{strings.help1.map((help, i) =>
												<Help help={help} key={i} /> 
											)}
											{this.renderHelp()}
										</div>
									</React.Fragment>
								}
							</div>
						</React.Fragment>
					)}
					<hr />
					
					{this.renderDates()}
				</div>	
			)
		} else {
			return null;
		}
	};

	renderDates = () => {
		return (
			<div className="row" id="your-event-dates">
				<div className="col-12">
					<h1>{strings.eventDates}</h1>
					{ ((this.props.dates.length > 0 && this.props.event.prices.length > 0 && this.props.event.venue.sections.length > 0) || this.props.isEditMode && this.props.dates.length > 0) &&
						<div className="showtix-form__group">
							<button
								className="showtix-button showtix-background__primary-1"
								onClick={this.props.toggleGlobalPriceModal}
							><span>{strings.globalCustomPricing}</span></button>
						</div>		
					}
				</div>
				{this.props.dates.map((date, i) => {
					const dateString = moment(date.date.toString().substring(0,15) + ' ' + date.time).format('LLLL');
					return (
						<div className="col-12 col-lg-6" key={i}>
							<div className="showtix-event">
								<div className="showtix-event__header">
									{dateString} 
									<button
										className="showtix-action showtix-action__delete"
										id={i}
										onClick={this.props.toggleConfirmDeleteEvent}
									>
										<img
											className="delete-icon"
											src={deleteIcon}
											alt="Delete"
										/>
									</button>
								</div>

								<div className="showtix-event__body js-toggle-content-1 is-active">
									
									<div className="row">
										<div className="col-12 col-sm-4 col-md-6">
											<div className="showtix-form__group">
												<label className="showtix-label" htmlFor={"event" + i + "-date"}>{strings.eventDateTime}*</label>

												<div className="showtix-form__multiple">
													<div className="showtix-form__input">
														<SingleDatePickerWrapper 
															object="date" 
															name="" 
															id={"event" + i + "-date"}
															event={i}
															disablePrevious={true}
															handleDayChange={this.handleDayEventChange}
															selectedDays={date.date}
														/>
													</div>

													<div className="showtix-form__select">
														<select
															className="showtix-input"
															object="time" 
															name="" 
															id={"event" + i + "-time"}
															event={i}
															value={date.time}
															onChange={this.props.handleChangeEvent}
														>
															<TimeOptions />
														</select>
													</div>
												</div>
											</div>
										</div>
										<div className="col-12 col-sm-4 col-md-6">
											<div className="showtix-form__group">
												<label className="showtix-label" htmlFor={"event" + i + "-subtitle"}>{strings.subtitle}</label>

												<div className="showtix-form__input">
													<input
														className="showtix-input"
														type="text"
														object="event_subtitle"
														name=""
														id={"event" + i + "-subtitle"}
														event={i}
														value={date.event_subtitle}
														onChange={this.props.handleChangeEvent}
													/>
												</div>
											</div>
										</div>
									</div>

									<div className="row">
										<div className="col-12 col-sm-4 col-md-6">
											<div className="showtix-form__group">
												<label className="showtix-label" htmlFor={"event" + i + "-presale-start_date"}>{strings.presaleStart}</label>

												<div className="showtix-form__multiple">
													<div className="showtix-form__input">
														<SingleDatePickerWrapper 
															object="presale" 
															name="start_date" 
															id={"event" + i + "-presale-start_date"}
															event={i}
															disablePrevious={true}
															handleDayChange={this.handleDayEventChange}
															selectedDays={date.presale.start_date}
														/>
													</div>

													<div className="showtix-form__select">
														<select
															className="showtix-input"
															object="presale" 
															name="start_time" 
															id={"event" + i + "-presale-start_time"}
															event={i}
															value={date.presale.start_time}
															onChange={this.props.handleChangeEvent}
														>
															<TimeOptions />
														</select>
													</div>
												</div>
											</div>
										</div>

										<div className="col-12 col-sm-4 col-md-6">
											<div className="showtix-form__group">
												<label className="showtix-label" htmlFor={"event" + i + "-presale-end_date"}>{strings.presaleEnd}</label>

												<div className="showtix-form__multiple">
													<div className="showtix-form__input">
														<SingleDatePickerWrapper 
															object="presale" 
															name="end_date" 
															id={"event" + i + "-presale-end_date"}
															event={i}
															disablePrevious={true}
															handleDayChange={this.handleDayEventChange}
															selectedDays={date.presale.end_date}
														/>
													</div>

													<div className="showtix-form__select">
														<select
															className="showtix-input"
															object="presale" 
															name="end_time" 
															id={"event" + i + "-presale-end_time"}
															event={i}
															value={date.presale.end_time}
															onChange={this.props.handleChangeEvent}
														>
															<TimeOptions />
														</select>
													</div>
												</div>
											</div>
										</div>

										<div className="col-12 col-sm-4 col-md-6">
											<div className="showtix-form__group">
												<label className="showtix-label" htmlFor={"event" + i + "-presale-password"}>{strings.presalePassword}</label>

												<div className="showtix-form__input">
													<input
														className="showtix-input"
														type="text"
														object="presale"
														name="presale_password"
														id={"event" + i + "-presale-password"}
														event={i}
														value={date.presale.presale_password}
														onChange={this.props.handleChangeEvent}
													/>
												</div>
											</div>
										</div>
									</div>


									<div className="row">
										<div className="col-12 col-sm-4 col-md-6">
											<div className="showtix-form__group">
												<label className="showtix-label" htmlFor={"event" + i + "-public-start_date"}>{strings.publicStart}*</label>

												<div className="showtix-form__multiple">
													<div className="showtix-form__input">
														<SingleDatePickerWrapper 
															object="public" 
															name="start_date" 
															id={"event" + i + "-public-start_date"}
															event={i}
															disablePrevious={true}
															handleDayChange={this.handleDayEventChange}
															selectedDays={date.public.start_date}
														/>
													</div>

													<div className="showtix-form__select">
														<select
															className="showtix-input"
															object="public" 
															name="start_time" 
															id={"event" + i + "-public-start_time"}
															event={i}
															value={date.public.start_time}
															onChange={this.props.handleChangeEvent}
														>
															<TimeOptions />
														</select>
													</div>
												</div>
											</div>
										</div>

										<div className="col-12 col-sm-4 col-md-6">
											<div className="showtix-form__group">
												<label className="showtix-label" htmlFor={"event" + i + "-public-end_time"}>{strings.publicEnd}</label>

												<div className="showtix-form__select">
													<select
														className="showtix-input"
														object="public" 
														name="end_time" 
														id={"event" + i + "-public-end_time"}
														event={i}
														onChange={this.props.handleChangeEvent}
														value={date.public.end_time}
													>
														<option value="-1000">{strings.salesClosed}</option>
														<TimeBeforeOptionsPublic />
													</select>
												</div>
											</div>
										</div>
									</div>

									{ this.props.event.venue.sections.length > 0 &&
										<div className="row">
											<div className="col-12">
												<button
													className=
													"showtix-button showtix-background__primary-1"
													id={i}
													onClick={this.props.toggleDatesModal}
												>
													<span>{strings.customizePricing}</span>
												</button>
											</div>
										</div>
									}
								</div>
							</div>
						</div>
					)}
				)}
			</div>
		);
	}

	renderVODDates = () => {
		if (this.props.event.details.event_type === 'Video On Demand') {
			const date = this.props.vod_date;
			return (
				<div className="container">
					<h1>{strings.titleDateVOD}</h1>
					<div className="row">
						<div className="col-12">
							<div className="row">
								<div className="col-12 col-md-4">
									<div className="showtix-form__group">
										<label className="showtix-label" htmlFor="vod-event_subtitle">{strings.subtitle}</label>

										<div className="showtix-form__input">
											<input
												className="showtix-input"
												type="text"
												object=""
												name="event_subtitle"
												id="vod-event_subtitle"
												onChange={this.props.handleChangeVOD}
												value={date.event_subtitle}
											/>
										</div>
									</div>
								</div>
							</div>
							<div className="row">
								<div className="col-12 col-md-4">
									<div className="showtix-form__group">
										<label className="showtix-label" htmlFor="vod-presale-start_date">{strings.presaleStart}
											<span id="tooltip-presaleStart" className="showtix-tooltip">!</span>
											<Tooltip placement="top" target="tooltip-presaleStart">
												{strings.presaleStartTooltip}
											</Tooltip>
										</label>

										<div className="showtix-form__multiple">
											<div className="showtix-form__input">
												<SingleDatePickerWrapper 
													object="presale" 
													name="start_date" 
													id="vod-presale-start_date"
													disablePrevious={true}
													handleDayChange={this.handleDayVODChange}
													selectedDays={date.presale.start_date}
												/>
											</div>

											<div className="showtix-form__select">
												<select
													className="showtix-input"
													object="presale" 
													name="start_time" 
													id="vod-presale-start_time"
													onChange={this.props.handleChangeVOD}
													value={date.presale.start_time}
												>
													<TimeOptions />
												</select>
											</div>
										</div>
									</div>
								</div>

								<div className="col-12 col-md-4">
									<div className="showtix-form__group">
										<label className="showtix-label" htmlFor="vod-presale-end_date">{strings.presaleEnd}</label>

										<div className="showtix-form__multiple">
											<div className="showtix-form__input">
												<SingleDatePickerWrapper 
													object="presale" 
													name="end_date" 
													id="vod-presale-end_date"
													disablePrevious={true}
													handleDayChange={this.handleDayVODChange}
													selectedDays={date.presale.end_date}
												/>
											</div>

											<div className="showtix-form__select">
												<select
													className="showtix-input"
													object="presale" 
													name="end_time" 
													id="vod-presale-end_time"
													onChange={this.props.handleChangeVOD}
													value={date.presale.end_time}
												>
													<TimeOptions />
												</select>
											</div>
										</div>
									</div>
								</div>

								<div className="col-12 col-md-4">
									<div className="showtix-form__group">
										<label className="showtix-label" htmlFor="vod-presale-password">{strings.presalePassword}</label>

										<div className="showtix-form__input">
											<input
												className="showtix-input"
												type="text"
												object="presale"
												name="presale_password"
												id="vod-presale-password"
												onChange={this.props.handleChangeVOD}
												value={date.presale.presale_password}
											/>
										</div>
									</div>
								</div>
							</div>

							<div className="row">
								<div className="col-12 col-md-4">
									<div className="showtix-form__group">
										<label className="showtix-label" htmlFor="vod-public-start_date">{strings.publicStart}*
											<span id="tooltip-publicStart" className="showtix-tooltip">!</span>
											<Tooltip placement="top" target="tooltip-publicStart">
												{strings.publicStartTooltip}
											</Tooltip>
										</label>

										<div className="showtix-form__multiple">
											<div className="showtix-form__input">
												<SingleDatePickerWrapper
													object="public"
													name="start_date"
													id="vod-public-start_date"
													disablePrevious={true}
													handleDayChange={this.handleDayVODChange}
													selectedDays={date.public.start_date}
												/>
											</div>

											<div className="showtix-form__select">
												<select
													className="showtix-input"
													object="public"
													name="start_time"
													id="vod-public-start_time"
													onChange={this.props.handleChangeVOD}
													value={date.public.start_time}
												>
													<TimeOptions />
												</select>
											</div>
										</div>
									</div>
								</div>

								<div className="col-12 col-md-4">
									<div className="showtix-form__group">
										<label className="showtix-label" htmlFor="vod-public-end_date">{strings.publicEnd}*
											<span id="tooltip-publicEnd" className="showtix-tooltip">!</span>
											<Tooltip placement="top" target="tooltip-publicEnd">
												{strings.publicEndTooltip}
											</Tooltip>
										</label>

										<div className="showtix-form__multiple">
											<div className="showtix-form__input">
												<SingleDatePickerWrapper
													object="public"
													name="end_date"
													id="vod-public-end_date"
													disablePrevious={true}
													handleDayChange={this.handleDayVODChange}
													selectedDays={date.public.end_date}
												/>
											</div>

											<div className="showtix-form__select">
												<select
													className="showtix-input"
													object="public"
													name="end_time"
													id="vod-public-end_time"
													onChange={this.props.handleChangeVOD}
													value={date.public.end_time}
												>
													<TimeOptions />
												</select>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div className="row">
								<div className="col-12 col-md-4"></div>

								<div className="col-12 col-md-4"></div>

								<div class="col-12 col-md-4">
									{/* strings.help4.map((help, i) =>
										<Help help={help} key={i} />
									) */}
								</div>
							</div>
							{this.props.isWizardError &&
								<div className="showtix-note error">
									{strings.publicSaleError}
								</div>
							}

							{ (this.props.dates.length > 0 && this.props.event.prices.length > 1 && this.props.event.venue.sections.length > 0) &&
								<div className="row">
									<div className="col-12">
										<div className="showtix-form__group">
											<button
												className="showtix-button showtix-background__primary-1"
												onClick={this.props.toggleDatesModal}
												//onClick={this.props.toggleGlobalPriceModal}
												id={0}
											><span>{strings.customizePricing}</span></button>
										</div>
									</div>
								</div>
							}
							{/* <div className="row">
								<div className="col-12">
									<button
										className="showtix-button showtix-background__primary-4"
										onClick={this.props.createEventVOD}
										disabled={!this.props.isReadyVOD}
									>
										<span>{strings.createEvent}</span>
									</button>
								</div>
							</div> */}
						</div>
					</div>
					<hr />
					<h1>{strings.titleAvailability}</h1>
					<div className="row">
						<div className="col-12 col-md-8">
							<div className="row">
								<div className="col-12 col-md-6">
									<div className="showtix-form__group">
										<label
											className="showtix-label"
											htmlFor="vod-redeem_start"
											dangerouslySetInnerHTML={{ __html: strings.availableStart}}
										/>

										<div className="showtix-form__multiple">
											<div className="showtix-form__input">
												<SingleDatePickerWrapper 
													name="start_date" 
													object="redeem" 
													id="vod-redeem_start"
													disablePrevious={true}
													handleDayChange={this.handleDayVODChange}
													selectedDays={date.redeem.start_date}
												/>
											</div>

											<div className="showtix-form__select">
												<select
													className="showtix-input"
													object="redeem" 
													name="start_time" 
													id="vod-redeem_start_time"
													onChange={this.props.handleChangeVOD}
													value={date.redeem.start_time}
												>
													<TimeOptions />
												</select>
											</div>
										</div>
									</div>
								</div>

								<div className="col-12 col-md-6">
									<div className="showtix-form__group">
										<label
											className="showtix-label"
											htmlFor="vod-redeem_end"
											dangerouslySetInnerHTML={{ __html: strings.noAvailable}}
										/>

										<div className="showtix-form__multiple">
											<div className="showtix-form__input">
												<SingleDatePickerWrapper 
													name="end_date" 
													object="redeem"
													id="vod-redeem_end"
													disablePrevious={true}
													handleDayChange={this.handleDayVODChange}
													selectedDays={date.redeem.end_date}
												/>
											</div>

											<div className="showtix-form__select">
												<select
													className="showtix-input"
													object="redeem"
													name="end_time" 
													id="vod-redeem_end_time"
													onChange={this.props.handleChangeVOD}
													value={date.redeem.end_time}
												>
													<TimeOptions />
												</select>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="col-12 col-md-4">
							{strings.help3.map((help, i) =>
								<Help help={help} key={i} />
							)}
						</div>
					</div>
				</div>	
			)
		} else {
			return null;
		}
	};

	render() { 
		
		return ( 
			<div className="showtix-section showtix-background__primary-3">
				{this.renderWizard()}
				{this.renderVODDates()}
			</div>
		)
	}
}

Dates.propTypes = {
    wizard: PropTypes.shape({
        time: PropTypes.string,
        dates: PropTypes.array,
        prices: PropTypes.array
    }),
    dates: PropTypes.array,
    handleChangeEvent: PropTypes.func,
    handleChangeDateWizard: PropTypes.func,
    handleChangeDateEvent: PropTypes.func,
    toggleDatesModal: PropTypes.func,
    toggleConfirmDeleteEvent: PropTypes.func,
    assignPricingToAll: PropTypes.func,
    createEvents: PropTypes.func,
}
 
export default Dates;


// WEBPACK FOOTER //
// ./src/components/CreateEvent/Dates/Dates.js